var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import '../scss/frontend.scss';
import Sliders from './components/swiper-init';
function ready() {
    const header = document.querySelector('.site-header');
    let isSafari = false;
    const ua = navigator.userAgent;
    if (/Safari/.test(ua) && !/Chrome|Chromium|CriOS|FxiOS/.test(ua)) {
        isSafari = true;
    }
    if (isSafari) {
        document.documentElement.classList.add('safari');
    }
    Sliders.initBlogHeroSlider();
    const scrollToElement = (selector, offset = 0) => {
        const element = document.querySelector(selector);
        if (element) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
            return true;
        }
        return false;
    };
    window.document.addEventListener('scroll', () => {
        const operationType = header && Math.floor(window.scrollY) > 20 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
    });
    const scrollToSavePosition = () => {
        const scrollPos = sessionStorage.getItem('scrollPosition');
        if (scrollPos) {
            window.scrollTo({
                top: parseInt(scrollPos, 10),
                behavior: 'smooth',
            });
            sessionStorage.removeItem('scrollPosition');
        }
    };
    scrollToSavePosition();
    function filterBlogPostsByTerm(termId, page = 1, postsPerPage = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('action', 'filter_blog_posts_by_term');
            formData.append('term_id', termId);
            formData.append('page', page.toString());
            if (postsPerPage > 0) {
                formData.append('posts_per_page', postsPerPage.toString());
            }
            try {
                const response = yield fetch(var_from_php.ajax_url, {
                    method: 'POST',
                    body: formData
                });
                const result = yield response.json();
                if (result.success) {
                    const postsGrid = document.getElementById('blog-posts-grid');
                    if (postsGrid) {
                        postsGrid.innerHTML = result.data.html;
                    }
                    const zeroResultsElement = document.querySelector('.js-post-zero-results');
                    if (zeroResultsElement) {
                        zeroResultsElement.classList.add('active');
                        zeroResultsElement.textContent = `${result.data.total_posts} results`;
                    }
                    const paginationContainer = document.querySelector('.blog-posts__pagination.js-blog-posts-pagination');
                    if (paginationContainer instanceof HTMLElement) {
                        if (result.data.pagination) {
                            if (result.data.show_pagination) {
                                paginationContainer.classList.add('active');
                            }
                            else {
                                paginationContainer.classList.remove('active');
                            }
                            paginationContainer.innerHTML = result.data.pagination;
                        }
                        else {
                            paginationContainer.classList.remove('active');
                            paginationContainer.innerHTML = '';
                        }
                    }
                    applyTextTruncation();
                    scrollToElement('.js-filter-title', 170);
                }
            }
            catch (error) {
                console.error('Error filtering blog posts:', error);
            }
        });
    }
    const isPaginationPage = window.location.pathname.includes('/page/') || window.location.search.includes('paged=');
    const wasPaginationClicked = localStorage.getItem('paginationClicked') === 'true';
    if (isPaginationPage || wasPaginationClicked) {
        const scrollToResults = () => {
            const result = scrollToElement('.js-filter-title', 170);
            if (wasPaginationClicked) {
                localStorage.removeItem('paginationClicked');
            }
            return result;
        };
        if (!scrollToResults()) {
            setTimeout(() => {
                if (!scrollToResults()) {
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            scrollToResults();
                        }, 50);
                    });
                }
            }, 100);
        }
    }
    document.body.addEventListener('click', (event) => {
        var _a, _b, _c, _d, _e, _f;
        const target = event.target;
        const href = target.getAttribute('href');
        const isPaginationLink = target.tagName === 'A' &&
            (target.classList.contains('ajax-page-link') ||
                target.classList.contains('blog-posts__pagination-prev') ||
                target.classList.contains('blog-posts__pagination-next') ||
                ((_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains('blog-posts__pagination-prev')) ||
                ((_b = target.parentElement) === null || _b === void 0 ? void 0 : _b.classList.contains('blog-posts__pagination-next')) ||
                (href && (href.includes('/page/') || href.includes('paged='))));
        if (isPaginationLink) {
            localStorage.setItem('paginationClicked', 'true');
        }
        else {
            const termId = target.getAttribute('data-term-id') || ((_c = target.parentElement) === null || _c === void 0 ? void 0 : _c.getAttribute('data-term-id'));
            const page = target.getAttribute('data-page') || ((_d = target.parentElement) === null || _d === void 0 ? void 0 : _d.getAttribute('data-page'));
            const postsPerPage = target.getAttribute('data-posts-per-page') || ((_e = target.parentElement) === null || _e === void 0 ? void 0 : _e.getAttribute('data-posts-per-page'));
            if (termId && page && postsPerPage) {
                event.preventDefault();
                const currentUrl = new URL(window.location.href);
                const path = currentUrl.pathname.replace(/\/page\/\d+\//g, '/');
                const newUrl = path + currentUrl.search;
                window.history.pushState({}, '', newUrl);
                const filterTermId = target.getAttribute('data-term-id') || ((_f = target.parentElement) === null || _f === void 0 ? void 0 : _f.getAttribute('data-term-id'));
                if (filterTermId) {
                    filterBlogPostsByTerm(filterTermId, 1, 0);
                }
            }
        }
    });
    document.body.addEventListener('click', (event) => {
        const target = event.target;
        const ROLE = target.dataset.role;
        if (!ROLE)
            return;
        switch (ROLE) {
            case 'smooth-scroll-to-target-element': {
                const href = target.getAttribute('href');
                if (!href || !href.startsWith('#'))
                    return;
                event.preventDefault();
                const targetElement = document.querySelector(href);
                if (targetElement) {
                    const headerOffset = 150;
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
                break;
            }
            case 'filter-blog-posts': {
                const termId = target.dataset.termId;
                if (termId) {
                    const searchInput = document.querySelector('.js-blog-posts-search-input');
                    if (searchInput) {
                        searchInput.value = '';
                    }
                    const letterElements = document.querySelectorAll('.js-blog-post-letter');
                    letterElements.forEach(element => {
                        element.classList.remove('active');
                    });
                    const currentUrl = new URL(window.location.href);
                    const path = currentUrl.pathname.replace(/\/page\/\d+\//g, '/');
                    const newUrl = path;
                    window.history.pushState({}, '', newUrl);
                    filterBlogPostsByTerm(termId, 1, 0);
                }
                break;
            }
            case 'filter-blog-posts-by-letter': {
                const letter = target.getAttribute('data-letter');
                if (letter) {
                    const letterElements = document.querySelectorAll('.js-blog-post-letter');
                    letterElements.forEach(element => {
                        element.classList.remove('active');
                    });
                    target.classList.add('active');
                    const searchInput = document.querySelector('.js-blog-posts-search-input');
                    if (searchInput) {
                        searchInput.value = letter;
                    }
                    const currentUrl = new URL(window.location.href);
                    const path = currentUrl.pathname.replace(/\/page\/\d+\//g, '/');
                    const newUrl = path;
                    window.history.pushState({}, '', newUrl);
                    searchBlogPosts(letter, 1, 0);
                }
                break;
            }
            default:
                break;
        }
    });
    function searchBlogPosts(searchTerm, page = 1, postsPerPage = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('action', 'search_blog_posts');
            formData.append('search_term', searchTerm);
            formData.append('page', page.toString());
            if (postsPerPage > 0) {
                formData.append('posts_per_page', postsPerPage.toString());
            }
            try {
                const response = yield fetch(var_from_php.ajax_url, {
                    method: 'POST',
                    body: formData
                });
                const result = yield response.json();
                if (result.success) {
                    const postsGrid = document.getElementById('blog-posts-grid');
                    if (postsGrid) {
                        postsGrid.innerHTML = result.data.html;
                    }
                    const zeroResultsElement = document.querySelector('.js-post-zero-results');
                    if (zeroResultsElement) {
                        zeroResultsElement.classList.add('active');
                        zeroResultsElement.textContent = `${result.data.total_posts} results`;
                    }
                    const paginationContainer = document.querySelector('.blog-posts__pagination.js-blog-posts-pagination');
                    if (paginationContainer instanceof HTMLElement) {
                        if (result.data.pagination) {
                            if (result.data.show_pagination) {
                                paginationContainer.classList.add('active');
                            }
                            else {
                                paginationContainer.classList.remove('active');
                            }
                            paginationContainer.innerHTML = result.data.pagination;
                        }
                        else {
                            paginationContainer.classList.remove('active');
                            paginationContainer.innerHTML = '';
                        }
                    }
                    applyTextTruncation();
                    scrollToElement('.js-filter-title', 170);
                }
            }
            catch (error) {
                console.error('Error searching blog posts:', error);
            }
            const searchButton = document.querySelector('.blog-posts__search-submit');
            if (searchButton) {
                searchButton.classList.remove('loading');
            }
        });
    }
    function updateLetterFilters(searchTerm) {
        const letterElements = document.querySelectorAll('.js-blog-post-letter');
        letterElements.forEach(element => {
            element.classList.remove('active');
        });
        if (searchTerm && searchTerm.length > 0) {
            const firstLetter = searchTerm.charAt(0).toUpperCase();
            const matchingLetterElement = document.querySelector(`.js-blog-post-letter[data-letter="${firstLetter}"]`);
            if (matchingLetterElement) {
                matchingLetterElement.classList.add('active');
            }
        }
    }
    const searchInput = document.querySelector('.js-blog-posts-search-input');
    if (searchInput) {
        let placeholderTimeout = null;
        searchInput.addEventListener('focus', () => {
            if (searchInput.value.trim() === '') {
                placeholderTimeout = window.setTimeout(() => {
                    const originalPlaceholder = searchInput.placeholder;
                    searchInput.setAttribute('data-original-placeholder', originalPlaceholder);
                    searchInput.classList.add('placeholder-fade-out');
                    setTimeout(() => {
                        searchInput.placeholder = '';
                        searchInput.classList.remove('placeholder-fade-out');
                        searchInput.classList.add('placeholder-hidden');
                    }, 500);
                }, 3000);
            }
        });
        searchInput.addEventListener('blur', () => {
            if (placeholderTimeout) {
                clearTimeout(placeholderTimeout);
                placeholderTimeout = null;
            }
            if (searchInput.value.trim() === '') {
                const originalPlaceholder = searchInput.getAttribute('data-original-placeholder');
                if (originalPlaceholder) {
                    searchInput.classList.remove('placeholder-fade-out', 'placeholder-hidden');
                    searchInput.placeholder = originalPlaceholder;
                }
            }
        });
        searchInput.addEventListener('input', () => {
            if (placeholderTimeout) {
                clearTimeout(placeholderTimeout);
                placeholderTimeout = null;
            }
            if (searchInput.value.trim() === '') {
                const originalPlaceholder = searchInput.getAttribute('data-original-placeholder');
                if (originalPlaceholder) {
                    searchInput.classList.remove('placeholder-fade-out', 'placeholder-hidden');
                    searchInput.placeholder = originalPlaceholder;
                }
            }
            else {
                searchInput.classList.add('placeholder-fade-out');
                setTimeout(() => {
                    searchInput.placeholder = '';
                    searchInput.classList.remove('placeholder-fade-out');
                    searchInput.classList.add('placeholder-hidden');
                }, 500);
            }
        });
    }
    function truncateText(text, maxLength) {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + '...';
    }
    function applyTextTruncation() {
        const titleElements = document.querySelectorAll('.js-post-card-title');
        titleElements.forEach(element => {
            const originalText = element.textContent || '';
            if (originalText.length > 60 && !originalText.endsWith('...')) {
                element.textContent = truncateText(originalText, 60);
            }
        });
        const descElements = document.querySelectorAll('.js-post-card-desc');
        descElements.forEach(element => {
            const originalHTML = element.innerHTML;
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = originalHTML;
            const plainText = tempDiv.textContent || tempDiv.innerText || '';
            if (plainText.length > 160 && !element.innerHTML.endsWith('...')) {
                const truncatedText = truncateText(plainText, 160);
                element.innerHTML = truncatedText + '...';
            }
        });
    }
    applyTextTruncation();
    function handleSearch(searchTerm) {
        const searchButton = document.querySelector('.blog-posts__search-submit');
        if (searchButton) {
            searchButton.classList.add('loading');
        }
        updateLetterFilters(searchTerm);
        const currentUrl = new URL(window.location.href);
        const path = currentUrl.pathname.replace(/\/page\/\d+\//g, '/');
        const newUrl = path + currentUrl.search;
        window.history.pushState({}, '', newUrl);
        searchBlogPosts(searchTerm, 1, 0);
    }
    const searchForm = document.querySelector('.blog-posts__search-form');
    if (searchForm) {
        searchForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const searchInput = document.querySelector('.js-blog-posts-search-input');
            if (searchInput) {
                const searchTerm = searchInput.value.trim();
                handleSearch(searchTerm);
            }
        });
    }
    document.body.addEventListener('click', (event) => {
        const target = event.target;
        const ROLE = target.dataset.role;
        if (ROLE === 'search-blog-posts') {
            event.preventDefault();
            const searchInput = document.querySelector('.js-blog-posts-search-input');
            if (searchInput) {
                const searchTerm = searchInput.value.trim();
                handleSearch(searchTerm);
            }
        }
    });
    document.body.addEventListener('click', (event) => {
        const target = event.target;
        const searchTerm = target.getAttribute('data-search-term');
        if (searchTerm !== null) {
            event.preventDefault();
            const page = parseInt(target.getAttribute('data-page') || '1', 10);
            const postsPerPage = parseInt(target.getAttribute('data-posts-per-page') || '0', 10);
            const currentUrl = new URL(window.location.href);
            const path = currentUrl.pathname.replace(/\/page\/\d+\//g, '/');
            const newUrl = path + currentUrl.search;
            window.history.pushState({}, '', newUrl);
            searchBlogPosts(searchTerm, page, postsPerPage);
        }
    });
    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(() => {
            applyTextTruncation();
        }, 100);
    });
}
window.document.addEventListener('DOMContentLoaded', ready);
